import React from 'react'
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form'

type FormProps<TFormValues extends FieldValues> = {
  onSubmit: SubmitHandler<TFormValues>
  children: React.ReactNode
}

export const Form = <TFormValues extends FieldValues>({
  onSubmit,
  children,
}: FormProps<TFormValues>) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<TFormValues>()

  // TODO: make this customizable
  const styleProps = {
    marginBottom: '2',
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {React.Children.map(children, child => {
        const elementChild = child as React.ReactElement

        if (!elementChild.props.name) {
          return child
        }

        return React.createElement(elementChild.type, {
          ...elementChild.props,
          register: register,
          key: elementChild.props.name,
          error: errors[elementChild.props.name],
          ...styleProps,
        })
      })}
    </form>
  )
}
